export const COLORS = {
  STATUS: {
    INITIATED: 'blue',
    IN_PROGRESS: 'success',
    STANDBY: 'warning',
    STANDBY_INSURER: 'pink',
    DONE: 'gray',
  },
  ALERTS: {
    MARC: 'warning',
    ANL: 'error',
    RMEV: 'orange',
  },
} as const;
